import React from "react";

export type SubmitContextListener = {
  callback: () => Promise<boolean> | boolean;
  id: string;
  ref: React.RefObject<any>;
};
export interface SubmitContextProps {
  listeners: SubmitContextListener[];
  subscribe: (listener: SubmitContextListener) => void;
  unsubscribe: (listener: SubmitContextListener) => void;
  validate: (id: string) => Promise<boolean> | boolean;
}

export const SubmitContext = React.createContext<SubmitContextProps | null>(null);
